module.exports = __webpack_public_path__ + "img/screen3.6656df6.png";